module.exports = __webpack_public_path__ + "img/chevron.6fc09042.svg";